// extracted by mini-css-extract-plugin
module.exports = {"modal":"TabellaCompatibilitaVolantiniModal_modal__RniGp","rotation":"TabellaCompatibilitaVolantiniModal_rotation__ENO6b"};